<template>
  <div class="nx-dayparting-calendar-event" :style="styledPosition">
    <v-tooltip bottom dark>
      <template #activator="{ on: tooltip }">
        <v-menu offset-y max-width="300">
          <template #activator="{ on: menu }">
            <div class="nx-dayparting-calendar-event__text" v-on="{ ...tooltip, ...menu }">
              <span v-if="event.starting"><v-icon color="#D7E0ED" small>today</v-icon> {{ event.data.name }}</span>
            </div>
          </template>
          <v-list v-if="!disabled">
            <v-list-tile @click="editModule" v-if="eventHasModuleId(event)">
              <v-list-tile-avatar>
                <v-icon>edit</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-title>{{ $t('message.dayparting.actions.edit') }}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="editEvent">
              <v-list-tile-avatar>
                <v-icon>today</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-title>{{ $t('message.dayparting.actions.editEvent') }}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="remove">
              <v-list-tile-avatar>
                <v-icon>delete</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-title>
                {{ $t('message.dayparting.actions.delete') }}
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </template>
      <span>{{ event.data.name }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { CalendarEvent } from 'dayspan';

export default {
  name: 'nx-dayparting-calendar-event',
  props: {
    event: {
      type: CalendarEvent,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    styledPosition() {
      const startDelta = Math.max(this.event.startDelta, 0);
      const endDelta = Math.min(this.event.endDelta, 1);

      return {
        'background-color': this.event.data.color || false,
        'margin-left': `${startDelta * 100}%`,
        'margin-right': `${100 - endDelta * 100}%`,
        'border-top-left-radius': this.event.starting ? '3px' : '0px',
        'border-top-right-radius': this.event.ending ? '3px' : '0px',
        'border-bottom-left-radius': this.event.starting ? '3px' : '0px',
        'border-right-left-radius': this.event.ending ? '3px' : '0px',
      };
    },
  },
  methods: {
    eventHasModuleId(event) {
      return event.data.moduleId;
    },
    editModule() {
      this.$emit('editModule', this.event.data.moduleId);
    },
    editEvent() {
      this.$emit('edit', this.event.event.id);
    },
    remove() {
      this.$emit('remove', this.event.event.id);
    },
  },
};
</script>
<style lang="stylus">
.nx-dayparting-calendar-event {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: block;
  margin: 10px 0;
  color: #D7E0ED
  background-color: #212976;
  max-width: 100%;
  min-height: 21px;
  cursor: pointer;

  &__text {
    display: block;
    padding: 0 4px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    height: 100%;
    width: 100%;
  }
}
</style>
